<nb-layout>
    <nb-layout-header fixed *ngIf="isMobile && isOnAdmin">
        <app-toolbar (menuToggle)="toggleSidenav()"></app-toolbar>
    </nb-layout-header>
    <nb-layout-column>
        <mat-sidenav-container>
            <mat-sidenav [fixedInViewport]="true" #menuSidenav [mode]="isMobile ? 'over' : 'side'" *ngIf="isOnAdmin" opened>
                <app-sidenav (menuToggle)="toggleSidenav()" [showClose]="isMobile"></app-sidenav>
            </mat-sidenav>
            <mat-sidenav-content>
                <app-toolbar *ngIf="!isMobile && isOnAdmin" (menuToggle)="toggleSidenav()"></app-toolbar>
                <main>
                    <router-outlet></router-outlet>
                </main>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </nb-layout-column>
</nb-layout>
